import Vue from 'vue';
import Vuex from 'vuex';

import goods_create from './modules/goods_create.js';
import user from './modules/user.js';
import menu from './modules/menu.js';
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		refreshTrigger: 0, // 用于触发刷新
	  },
	  mutations: {
		triggerRefresh(state) {
		  state.refreshTrigger += 1; // 每次刷新时递增
		},
	  },
	  actions: {
		triggerRefresh({ commit }) {
		  commit('triggerRefresh');
		},
	  },
	modules:{
		goods_create,
		user,
		menu
	}
})